export enum WebshareLoadImageMethod {
    Server = 'Server',
    Client = 'Client',
    Auto  = 'Auto'
}

export enum WebshareAuthType {
    Manual = 'Manual',
    Automatic = 'Automatic',
    Enterprise  = 'Enterprise',
    Sphere = 'Sphere'
}

export enum PointCloudProvider {
    Webshare = 'WEBSHARE',
    SphereXG = 'SPHEREXG',
}

export interface IPointCloudSession {
    id?: number;
    companyId?: number;
    name?: string;
    browserDomainUrl?: string;
    domainUrl: string;
    apiKey?: string;
    loginMethod?: string;
    partnerName?: string;
    loadImageMethod?: string;
}

export interface IWebShareConf {
    id?: number;
    companyId: number;
    name: string;
    browserDomainUrl: string;
    domainUrl: string;
    apiKey?: string;
    loginMethod: string;
    partnerName?: string;
    loadImageMethod: string;
}

export interface ISphereXgConfig {
    id?: number;
    companyId?: number;
    name: string;
    domainHost: string;
	subject: string;
	audience: string;
	issuer: string;
	publicKey: string;
	privateKey: string;
}